
import React from 'react'

class InlineDocumentation extends React.Component {

    static defaultProps = {
        title: null,
        subtitle: null,
        brief: null,
        content: null,
        contentList: null  //[{ content: '' }]
    }

    render() {

        return (
            <div>
                {this.renderSteps()}
            </div>
        )
    }

    renderSteps = () => {

        let { title, subtitle, abstract, brief, content, contentList } = this.props;

        return (
            <div className="card m-2 p-3">
                <div className="card-body">
                    {!!title && <h4 className="card-title text-info text-center">{title}</h4>}
                    {!!subtitle && <h5><p className="card-subtitle text-secondary text-center">{subtitle}</p></h5>}
                    {!!(title || subtitle) && <hr />}
                    {!!brief && <div><p className='text-info'>{brief}</p> <p /><p /></div>}
                    {!!abstract && <p className='text-body'>
                        <h3>Abstract</h3><i>{abstract}</i></p>}
                    {!!content && <p className='card-text'>{content}</p>}
                    {!!contentList &&
                        <ul className="list-group card-text">{contentList.map(item => item ?
                            <li className='list-group-item font-weight-light border-0'><b className='font-weight-bold'>{item.title}</b>: {item.content}</li>
                            : null)}
                        </ul>}
                </div>
            </div>
        );
    }
}

export default InlineDocumentation;
export {
    InlineDocumentation
}
